import { rootStateBranchSelector } from 'shared/utils/rootStateBranchSelector';

export const offersCountTooltipSelector = rootStateBranchSelector('offersCountTooltip');
